import React, {useState, useEffect} from 'react'
import useDebounce from '../../context/hooks/useDebounce';
import { Form, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../../context/hooks/useAxiosPrivate';
import {Button, Table, Spinner} from 'react-bootstrap';
import ListPaginator from '../../components/ListPaginator';
import '../../appstyles/ClientsCSS/ClientsList.css';
import PermissionWrapper from '../../context/PermissionWrapper';
import ExcelQuoteRequest from '../../components/ExcelQuoteRequest';

function RequestList() {
    const axiosInstance = useAxiosPrivate();
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [search, setSearch] = useState('');
    const debouncedSearch = useDebounce(search, 700);
    const navigate = useNavigate();

    const fetchRequests = (page, pageSize, searchQuery) => {
        setLoading(true)
        const url = searchQuery
          ? `api/quote/?page=${page}&size=${pageSize}&status=Solicitado&search=${searchQuery}`
          : `api/quote/?page=${page}&size=${pageSize}&status=Solicitado`;
        axiosInstance.get(url)
          .then(response => {
            setRequests(response.data.data);
            setTotalPages(response.data.totalPages); 
          })
          .catch(error => {
            console.log('Failed to fetch requests', error);
          })
          .finally(() => {
            setLoading(false)
          });
    }

    useEffect(() => {
        fetchRequests(currentPage, rowsPerPage, debouncedSearch);
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [currentPage, rowsPerPage, debouncedSearch]);

    const handleRowClick = (requestId) => {
    navigate(`/request/details/${requestId}`);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };


  return (
    <div className='maestros-list'>
      <h2>Tabla de Solicitudes</h2>
      <hr />
      <Row style={{ alignItems: 'center', marginBottom: '1rem' }}>
        <Col md={6}>
          <Form inline style={{ width: '100%' }} onSubmit={e => e.preventDefault()}>
            <Form.Control
              style={{ width: '100%' }}
              type="search"
              placeholder="Buscar por cliente o ID"
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </Form>
        </Col>
      </Row>
      <PermissionWrapper feature="solicitud" action="create">
        <Button 
            variant="primary"
            style={{ 
                marginBottom: '20px', 
                width: '35%',
                backgroundColor: '#056664',
                border: ' solid 2px #025C5A',
            }}
            onClick={() => navigate('/requestform')}
        >
            Crear nueva solicitud
        </Button>
      </PermissionWrapper>

      {/* Controls moved to bottom */}
      {loading ? ( 
          <div className='loading-container'>
          <p style={{fontFamily: 'Roboto, sans-serif'}}>Cargando...</p>
          <Spinner animation="border" variant="info" style={{width: '4.5rem', height: '4.5rem'}} />
          </div>
      ) : (  
      <Table striped bordered hover responsive
          style={{overflowY: 'auto'}}
      >
          <thead>
              <tr>
                  <th>ID</th>
                  <th>Cliente</th>
                  <th>Producto</th>
                  <th>Fabricante</th>
                  <th>Pedido</th>
                  <th>Incoterm</th>
                  <th>Fecha Solicitada</th>
                  <th>Fecha de Creación</th>
                  <th>Creado por</th>
              </tr>
          </thead>
          <tbody>
              {requests.map( request => (
                  <tr key={request.quote_id} onClick={() => handleRowClick(request.quote_id)} style={{ cursor: 'pointer' }}>
                      <td>{request.quote_id}</td>
                      <td>{request.client_name}</td>
                      <td>
                        {request.products.length > 0 ? request.products[0].product_name : ''}
                        {request.products.length > 1 ? ', ...' : ''}
                      </td>
                      <td>
                        {request.products.length > 0 ? request.products[0].product_manufacturer : ''}
                        {request.products.length > 1 ? ', ...' : ''}
                      </td>
                      <td>{request.products.length > 1 ? 'Combinado' : 'Individual'}</td>
                      <td>{request.incoterm}</td>
                      <td>{request.requested_delivery_date}</td>
                      <td>{request.requested_date}</td>
                      <td>{request.created_by ? request.created_by : 'N/A' }</td>
                  </tr>
              ))}
          </tbody>
      </Table>
      )}
      <Row style={{ alignItems: 'center', marginTop: '1.5rem' }}>
        <Col md={6} style={{ display: 'flex', alignItems: 'center' }}>
          <PermissionWrapper feature="solicitud" action="excel">
            <ExcelQuoteRequest status="Solicitado" />
          </PermissionWrapper>
        </Col>
        <Col md={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          <ListPaginator
            currentPage={currentPage}
            totalPages={totalPages}
            rowsPerPage={rowsPerPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={value => {
              setRowsPerPage(value);
              setCurrentPage(1);
            }}
          />
        </Col>
      </Row>
    </div>
  )
}

export default RequestList